<template>
  <div class="page-loader">
    <k-loader :size="150" :label="label" />
  </div>
</template>

<script>
import { KLoader } from '@kate/components';

export default {
  name: 'PageLoader',
  components: {
    KLoader,
  },
  props: {
    label: {
      type: String,
      default: 'Loading',
    },
  },
};
</script>

<style scoped>
.page-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(0 0 0 / 0.75);
}
</style>
